import styled from 'styled-components';

const DeltaWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    visibility: ${props => props.visible};
    color: ${props => props.theme.callouts.colors.neutral};
`;

const DeltaWrapperPositive = styled(DeltaWrapper)`
    color: ${props => props.theme.callouts.colors.positive};
`;

const DeltaWrapperNegative = styled(DeltaWrapper)`
    color: ${props => props.theme.callouts.colors.negative};
`;

export {
    DeltaWrapper as default,
    DeltaWrapperPositive,
    DeltaWrapperNegative
};



// WEBPACK FOOTER //
// ./src/components/atoms/callout/DeltaWrapper.js